define.alias("shared/components/shared/media-items/post-card", "calendar/components/shared/media-items/post-card");